import { useEffect, useState } from 'react';
import { useMarketplaceExperiment } from '../../contexts';
import { getEmptyCartSnapshot, getMarketplaceCartController } from '../../lib/marketplaceCart';

const disabledCartController = {
    checkout: async () => null,
    clearForLogout: () => {},
    close: async () => null,
    getSnapshot: getEmptyCartSnapshot,
    open: async () => null,
    prepareForLogout: async () => null,
    removeItem: async () => null,
    setSession: () => {},
    subscribe: () => () => {},
};

const useMarketplaceCart = () => {
    const { marketplaceEnabled: marketplaceCartEnabled } = useMarketplaceExperiment();
    const cartController = marketplaceCartEnabled
        ? getMarketplaceCartController(window)
        : disabledCartController;
    const [snapshot, setSnapshot] = useState(() => cartController.getSnapshot());

    useEffect(() => {
        if (!marketplaceCartEnabled) {
            setSnapshot(getEmptyCartSnapshot());
            return undefined;
        }

        return cartController.subscribe(setSnapshot);
    }, [cartController, marketplaceCartEnabled]);

    return {
        isEnabled: marketplaceCartEnabled,
        snapshot,
        controller: cartController,
    };
};

export default useMarketplaceCart;
